import { useGetBookmarkedNoticesMutation } from '@frontend/redux';
import withNoticeList from './withNoticeList';

const BookmarkedNotices = withNoticeList(
  useGetBookmarkedNoticesMutation,
);

export default BookmarkedNotices;
